import { useState, useRef, useEffect } from "react";
import Dialog from "./Dialog";

import extra from "../data/extra.json";
import movies from "../data/movies.json";
import music from "../data/music.json";
import news from "../data/news.json";
import sports from "../data/sports.json";
import ChannelCard from "./ChannelCard";
import "../styles/searchchannel.css";

const allChannels = [...extra, ...movies, ...music, ...news, ...sports];

const SearchChannel = ({ open, setOpen }) => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const inputRef = useRef();

  useEffect(() => {
    inputRef.current.focus();
    return () => {
      setResults([]);
      setQuery("");
    };
  }, []);

  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setOpen(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [open, setOpen]);

  const handleSearch = (value) => {
    setQuery(value);

    if (value.length > 1) {
      const filtered = allChannels.filter((item) =>
        item.name.toLowerCase().includes(value.toLowerCase())
      );
      setResults(filtered);
    } else {
      setResults([]);
    }
  };

  return (
    <Dialog isOpen={open} onClose={() => setOpen(false)} title="Search Channel">
      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <input
          ref={inputRef}
          type="text"
          placeholder="Enter a channel name"
          value={query}
          onChange={(e) => handleSearch(e.target.value)}
          style={{
            padding: "8px",
            fontSize: "14px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        />

        {/* Search Results */}
        {results.length > 0 ? (
          <div style={{ maxHeight: "500px", overflowY: "auto" }}>
            <div className="channels-list-minimal">
              {results.map((item) => (
                <ChannelCard channel={item} minimal={true} setOpen={setOpen} />
              ))}
            </div>
          </div>
        ) : (
          query && query.length > 2 && <small>No results found</small>
        )}

        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}
        ></div>
      </div>
    </Dialog>
  );
};

export default SearchChannel;
